import React from 'react';

const Hero = () => {
  return (
    <section className="hero" id="home">
      <div className="hero-content">
        <h2>Smart Thinking, Creative Solutions and Innovative Digital Experiences</h2>
        
        
      
      </div>
    </section>
  );
};

export default Hero; 